import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex h-full w-full flex-col items-stretch space-y-4 md:flex-row md:space-x-4 md:space-y-0"
}
const _hoisted_2 = { class: "flex w-full flex-col items-center justify-between rounded-lg bg-white p-6 shadow-md md:w-1/3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 text-lg font-semibold" }, "Passwordless", -1 /* HOISTED */)
const _hoisted_4 = { class: "w-full flex-grow" }
const _hoisted_5 = { class: "flex w-full flex-col items-center justify-between rounded-lg bg-white p-6 shadow-md md:w-1/3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 text-lg font-semibold" }, "Google Auth", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex-grow" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "flex w-full flex-col items-center justify-between rounded-lg bg-white p-6 shadow-md md:w-1/3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 text-lg font-semibold" }, "Passkey", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex-grow" }, null, -1 /* HOISTED */)
const _hoisted_11 = {
  key: 1,
  class: "mt-4 flex w-full flex-col"
}
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = { class: "m-auto h-[600px] w-[400px] overflow-hidden border" }
const _hoisted_14 = { class: "mt-8 w-full overflow-auto rounded bg-white p-4 shadow-md" }
const _hoisted_15 = { class: "whitespace-pre" }

import { onMounted, ref } from 'vue'

import useAuth from '@/popup/compositions/useWeb3Auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  props: {
    msg: {}
  },
  setup(__props: any) {

const {
  loggedIn,
  email,
  init,
  signInWithEmail,
  signInWithGoogle,
  signInWithPasskey,
  logout,
  getUserInfo,
  getAccounts,
  getUserName,
  getBalance,
  signMessage,
  sendTransaction,
  showPrivateKey,
  registerPasskey,
} = useAuth()

const consoleData = ref<string>('')



function uiConsole(args: unknown): void {
  consoleData.value = JSON.stringify(args || {}, undefined, 2)
}

async function _logout() {
  await logout()
  uiConsole('Logged out')
}

async function _getUserInfo() {
  const data = await getUserInfo()
  uiConsole(data)
}

async function _getAccounts() {
  const data = await getAccounts()
  uiConsole(data)
}

async function _getUserName() {
  const data = await getUserName()
  uiConsole(data)
}

async function _getBalance() {
  const data = await getBalance()
  uiConsole(data)
}

async function _signMessage() {
  const data = await signMessage()
  uiConsole(data)
}

async function _sendTransaction() {
  const data = await sendTransaction()
  uiConsole(data)
}

async function _showPrivateKey() {
  const data = await showPrivateKey()
  uiConsole(data)
}

async function _registerPasskey() {
  const data = await registerPasskey()
  uiConsole(data)
}

onMounted(async () => {
  init()
})

return (_ctx: any,_cache: any) => {
  const _component_Extension = _resolveComponent("Extension")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, null, {
    default: _withCtx(() => [
      (!_unref(loggedIn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                  type: "text",
                  placeholder: "Enter your email",
                  class: "w-full rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _unref(email)]
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "mt-4 w-full cursor-pointer rounded bg-blue-500 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-blue-600",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(signInWithEmail) && _unref(signInWithEmail)(...args)))
              }, " Login ")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("button", {
                class: "mt-4 w-full cursor-pointer rounded bg-blue-500 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-blue-600",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(signInWithGoogle) && _unref(signInWithGoogle)(...args)))
              }, " Login ")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("button", {
                class: "mt-4 w-full cursor-pointer rounded bg-blue-500 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-blue-600",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(signInWithPasskey) && _unref(signInWithPasskey)(...args)))
              }, " Login ")
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_unref(loggedIn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", { class: "flex w-full flex-row" }, [
              _createElementVNode("div", { class: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-7" }, [
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _getUserInfo
                }, " Get User Info "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _getAccounts
                }, " Get Accounts "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _getUserName
                }, " Get Username "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _getBalance
                }, " Get Balance "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _signMessage
                }, " Sign Message "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _sendTransaction
                }, " Send Transaction "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _showPrivateKey
                }, " Show Private Key "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-gray-800 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-gray-700",
                  onClick: _registerPasskey
                }, " Register Passkey "),
                _createElementVNode("button", {
                  class: "cursor-pointer rounded bg-red-500 px-4 py-2 font-semibold text-white shadow-md transition duration-200 hover:bg-red-600",
                  onClick: _logout
                }, " Logout ")
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Extension)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(consoleData.value), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})